import { render, staticRenderFns } from "./ChallengeInstance.vue?vue&type=template&id=00a6e550&"
import script from "./ChallengeInstance.vue?vue&type=script&lang=js&"
export * from "./ChallengeInstance.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeInstance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports